import React from 'react'
import './contact-info-tab.css'
import { MdContentCopy } from 'react-icons/md'
import StudentBadge from '../StudentBadge/StudentBadge'
import axios from 'axios'
import { baseUrl } from '../../../assets/Animations'
import { getRequestHeaders } from '../../../api'
import FindFamilyProfileSearchBox from './FindFamilyProfileSearchBox/FindFamilyProfileSearchBox'

let familyInfoSections = [
    {label: 'Name', displayType: 'array', type: ['primaryParentName','familyName']},
    {label: 'Email', displayType: 'array', type: ['primaryEmail']},
    {label: 'Phone Number', displayType: 'array', type: ['primaryCellphone']},
    {label: 'Address', displayType: 'object', type: ['address']},
    // {label: 'Availability', displayType: 'object', type: ['initialAvailability']},
    // {label: 'Notes', displayType: 'array', type: ['initialAvailabilityNotes']},
    {label: 'Message', displayType: 'object', type: ['todoDescription']},
]

const ContactInfoTab = ({modalInfo, setModalInfo, setCopyConfirmationPopup, familyInfo, loadingFamilyInfo, hookUpFamily, scheduledEvents, getFamilyInfo}) => {

    const copyNewStudentFormUrlToClipboard = () => {
        let schoolName = ''
        switch(modalInfo.whichSchool) {
            default:
                schoolName = 'app'
                break;
            case 'mma':
                schoolName = 'mountainside'
                break;
            case 'lsma':
                schoolName = 'lakeside'
                break;
            case 'tma':
                schoolName = 'treeside'
                break;
            case 'mor':
                schoolName = 'morningside'
                break;
            case 'psma':
                schoolName = 'parkside'
                break;
            case 'tem':
                schoolName = 'tempe'
                break;
            case 'den':
                schoolName = 'denton'
                break;
            case 'tul':
                schoolName = 'tulsa'
                break;
        }
        navigator.clipboard.writeText(`https://${schoolName}.atharo.app/new-student/${modalInfo.familyId}`)
        .then(() => {
            setCopyConfirmationPopup({show: true, title: 'New Student Form URL copied to clipboard!'})

        })
        .catch(err => console.log(err))
    }

    const copyEmailToClipboard = async () => {
        await navigator.clipboard.writeText(familyInfo.primaryEmail)

        alert('Email copied to clipboard!')
    }

    const copyPoliciesLink = async () => {
        await navigator.clipboard.writeText(`https://app.atharo.app/student-policies/${modalInfo.familyId}`)
        .then(() => {
            alert('Policies URL copied to clipboard!')
        })
        .catch(err => console.log(err))
    }

    const copyStudentInfoToClipboard = async () => {
        //set mouse to loading
        document.body.style.cursor = 'wait'
        document.getElementById('family-info-gutter__family-info-copy-btn').style.cursor = 'wait'
        axios.get(`${baseUrl}/school-management/${modalInfo.familyId}`, getRequestHeaders())
        .then(res => {
            document.body.style.cursor = 'default'
                    document.getElementById('family-info-gutter__family-info-copy-btn').style.cursor = 'default'
            formatAndCopyToClipboard(res.data)
        })
        .catch(err => console.log(err))
    }

    function formatAndCopyToClipboard(rawData) {
        const { 
          students, 
          familyName, 
          onboardDate, 
          address, 
          primaryEmail, 
          primaryParentName,
          primaryCellphone 
        } = rawData;
      
        const formattedStudents = students.map((student) => {
          const { 
            studentName, 
            dob, 
            experienceLevel, 
            lessonLength, 
            instrumentList 
          } = student;
      
          // Extract instrument names from the instrumentList
          const instruments = instrumentList && instrumentList.length > 0 
            ? instrumentList.map((instr) => instr.name).join(", ") 
            : "Not specified";
      
          return `
      Student: ${studentName.trim()}
      Age: ${dob ? calculateAge(dob) + " Years Old" : "Age not provided"}
      Instruments: ${instruments}
      Experience: ${experienceLevel || "No experience"}
      Lesson Length: ${lessonLength} Minutes
          `.trim();
        }).join("\n\n"); // Join multiple students with spacing between
      
        const formattedData = `
      Family Name: ${familyName}
      Primary Parent: ${primaryParentName}
      Address: ${formatAddress(address)}
      Email: ${primaryEmail || "Not provided"}
      Phone: ${primaryCellphone || "Not provided"}
      
      ${formattedStudents}
        `.trim();
      
        // Copy formatted data to clipboard
        navigator.clipboard.writeText(formattedData).then(() => {
            setCopyConfirmationPopup({show: true, title: 'Copied Family Info!'})
        }).catch(err => {
          console.error("Failed to copy to clipboard", err);
        });
      
        return formattedData;
      }

      function calculateAge(dob) {
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      }
      
      // Helper function to format address
      function formatAddress(address) {
        const { addressLine1, addressLine2, city, state, zipcode } = address;
        const zip = zipcode && zipcode.trim() ? ` ${zipcode.trim()}` : "";
        return `${addressLine1}${addressLine2 ? ` ${addressLine2}` : ""}, ${city}, ${state}${zip}`;
      }

    if(hookUpFamily) {
        return (
            loadingFamilyInfo 
            ? 
            <div className='family-info-gutter__loading-card'>
                <div className='family-info-gutter__loading-icon'>⌛</div>
                <div className='family-info-gutter__loading-title'>Loading family info</div>
                <div className='family-info-gutter__loading-subtitle'>
                    Pulling contact details, students, and notes from the database.
                </div>
                <div className='family-info-gutter__loading-skeleton-group'>
                    <div className='family-info-gutter__loading-skeleton family-info-gutter__loading-skeleton--long'></div>
                    <div className='family-info-gutter__loading-skeleton family-info-gutter__loading-skeleton--medium'></div>
                    <div className='family-info-gutter__loading-skeleton family-info-gutter__loading-skeleton--short'></div>
                </div>
            </div>
            :
            <div>
                <FindFamilyProfileSearchBox modalInfo={modalInfo} setModalInfo={setModalInfo} getFamilyInfo={getFamilyInfo} />
            </div>
        )
    } else {
        if(!familyInfo) {
            return (
                <div>
                    <div className='family-info-gutter__new-student-form-btn'>
                        <div className='family-info-gutter__new-student-form-btn__text' onClick={() => copyNewStudentFormUrlToClipboard()}>New Student Form</div>
                        <MdContentCopy />
                    </div>
                    <div className='family-info-gutter__family-with-id-missing'>This family has an ID but is not in the database for some reason. Feel free to send the family the "New Student Form" link again.</div>
                </div>
            )
        } else {
            return (
                <div>
                    <div className='family-info-gutter__new-student-form-btn' onClick={() => copyNewStudentFormUrlToClipboard()}>
                        <div className='family-info-gutter__new-student-form-btn__text'>New Student Form</div>
                        <MdContentCopy />
                    </div>
                    <div className='family-info-gutter__new-student-form-btn' id='family-info-gutter__family-info-copy-btn' onClick={() => copyStudentInfoToClipboard()}>
                        <div className='family-info-gutter__new-student-form-btn__text'>Student Info</div>
                        <MdContentCopy />
                    </div>
                    <div className='family-info-gutter__new-student-form-btn' id='family-info-gutter__family-info-copy-btn' onClick={() => copyPoliciesLink()}>
                        <div className='family-info-gutter__new-student-form-btn__text'>Student Policies</div>
                        <MdContentCopy />
                    </div>
                    <div className='family-info-gutter__scroll-wrapper'>
                        <div className='family-info-gutter__student-badge__wrapper'>
                            {modalInfo.studentList.map((student) => 
                                <StudentBadge 
                                    key={student.studentId}
                                    familyInfo={familyInfo} 
                                    student={student} 
                                    scheduledEvents={scheduledEvents}
                                />
                            )}
                        </div>
                        <div className='family-info-gutter__family-info-area'>
                            {familyInfoSections.map((section, index) => (
                                <div key={index} className='family-info-gutter__family-info-chunk' style={section.label === 'Email' ? {cursor: 'pointer'} : {cursor: 'default'}} onClick={() => section.label === 'Email' && copyEmailToClipboard()}>
                                    <div className='family-info-gutter__family-info-chunk__label'>{section.label}</div>
                                    <div className='family-info-gutter__family-info-chunk__details__wrapper'>
                                        {section.displayType === 'array' ?
                                         section.type.map((type,index) =>
                                            <div key={index} className='family-info-gutter__family-info-chunk__details'>
                                                {familyInfo && familyInfo[type]}                                    
                                            </div>    
                                        )
                                        :
                                        <div className='family-info-gutter__family-info-chunk__address'>
                                            {section.label === 'Address' && 
                                                <div>
                                                    {Object.keys(familyInfo[section.type]).map((key, index) => (
                                                        <div key={index}>{familyInfo[section.type][key]}</div>
                                                    ))}
                                                </div>
                                            }
    
                                            {section.label === 'Availability' &&
                                                <div>
                                                    {familyInfo[section.type] && Object.keys(familyInfo[section.type]).map((key, index) => (
                                                        <div key={index}>
                                                            {Object.keys(familyInfo[section.type][key]).map((day, index) => (
                                                                <div key={index}>{key}: {day}</div>
                                                            ))}
                                                        </div>
                                                    ))}
                                                </div>
                                            }
                                            {section.label === 'Message' &&
                                            <div className='contact-tab__message__wrapper'>
                                                <div>{modalInfo[section.type] === '' ? familyInfo.initialAvailabilityNotes : modalInfo[section.type]}</div>
                                            </div>
                                            }
                                        </div>
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )
    }

    }
}
export default ContactInfoTab
